import { useMutation, useQueryClient } from 'react-query'
import { QUERY_KEYS } from 'src/constants'

import { accountsService } from 'src/services/accounts.service'
import { IAccountByIdRespDto, IProfileUserResponse, IUpdateAccountWelcomeShowDto } from 'src/types'

export const useUpdateAccountWelcome = (userId?: string) => {
  const queryClient = useQueryClient()

  return useMutation(
    async (dto: IUpdateAccountWelcomeShowDto) => accountsService.updateAccountWelcome(dto),
    {
      onSuccess(data, vars) {
        if (!data) return

        queryClient.setQueryData([QUERY_KEYS.ACCOUNT], (prev?: IAccountByIdRespDto | null) => {
          return prev ? { ...prev, show_welcome: vars.show_welcome } : null
        })
        queryClient.setQueryData(
          [QUERY_KEYS.USER, userId],
          (prev?: IProfileUserResponse | null) => {
            const data = prev
            data!.show_welcome = vars.show_welcome
            return prev ? { ...prev, data } : null
          },
        )
      },
    },
  )
}
